import axios from '../../axios'



/**
 * 新增
 * @param data
 * @returns {Promise | Promise<unknown>}
 */
export const create = (data) => {
  return axios({
    url: '/berry-task/quartzInfo/create',
    method: 'post',
    data
  })
}


/**
 * 分页查询
 * @param data
 * @returns {Promise | Promise<unknown>}
 */
export const selectListPage = (data) => {
  return axios({
    url: '/berry-task/quartzInfo/select_list_page',
    method: 'post',
    data
  })
}

// 触发任务
export const trigger = (data) => {
  return axios({
    url: '/berry-task/quartzInfo/trigger',
    method: 'post',
    data
  })
}

// 停止任务
export const pause = (data) => {
  return axios({
    url: '/berry-task/quartzInfo/pause',
    method: 'post',
    data
  })
}


// 恢复任务
export const resume = (data) => {
  return axios({
    url: '/berry-task/quartzInfo/resume',
    method: 'post',
    data
  })
}

// 移除任务
export const remove = (data) => {
  return axios({
    url: '/berry-task/quartzInfo/remove',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/http/modules/quartz/quartzInfo.js